module.exports = __webpack_public_path__ + "img/header-weddingRingsMorningGlow.7270d1e.webp";